// import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
// import 'react-h5-audio-player/lib/styles.css';

import {Icon} from 'Icon'
import CurrentSong from 'components/CurrentSong';

export default function Player() {
	return (
		<div
			className="h-22 px-4 pr-6 border-t border-white border-opacity-5 flex justify-between items-center flex-shrink-0 w-full"
			style={{backgroundColor: '#181818'}}>
			<CurrentSong />
			<div style={{maxWidth: '722px', width: '40%'}} className="flex items-center flex-col gap-y-3">
				<div className="flex gap-x-4">
					<button className="mr-2">
						<Icon src="shuffle" size={16} className="text-white text-opacity-70 hover:text-opacity-100"/>
					</button>
					<button>
						<Icon src="playerPrev" size={16} className="text-white text-opacity-70 hover:text-opacity-100"/>
					</button>
					<button
						className="w-8 h-8 bg-white rounded-full flex items-center justify-center transform hover:scale-[1.06]">
						<Icon src="play" size={16} className="text-black"/>
					</button>
					<button>
						<Icon src="playerNext" size={16} className="text-white text-opacity-70 hover:text-opacity-100"/>
					</button>
					<button className="ml-2">
						<Icon src="repeat" size={16} className="text-white text-opacity-70 hover:text-opacity-100"/>
					</button>
				</div>
				<div className="flex items-center w-full gap-x-3">
					<div style={{fontSize: '11px'}} className="text-white text-opacity-60">00:00</div>
					<div className="group py-1 w-full">
						<div className="h-1 bg-white bg-opacity-20 rounded w-full relative">
							<div
								className="w-3 h-3 rounded-full bg-white shadow-spotify-shadow absolute top-1/2 left-0 -translate-y-1/2 opacity-0 -translate-x-1/2 group-hover:opacity-100"></div>
						</div>
					</div>
					<div style={{fontSize: '11px'}} className="text-white text-opacity-60">00:00</div>
				</div>
			</div>
			<div className="flex gap-x-4 justify-end" style={{minWidth: '180px', width: '30%'}}>
				<button>
					<Icon src="device" size={16} className="text-white text-opacity-70 hover:text-opacity-100" />
				</button>
				<div className="flex gap-x-2 items-center">
					<button>
						<Icon src="sound" size={16} className="text-white text-opacity-70 hover:text-opacity-100" />
					</button>
					<div className="group py-1 w-22">
						<div className="h-1 bg-white bg-opacity-40 rounded w-full relative"
						     style={{'--volume-progress': '100%'}}>
							<div className="h-1 w-[var(--volume-progress)] bg-spotify-green rounded opacity-0 group-hover:opacity-100"></div>
							<div
								className="w-3 h-3 rounded-full bg-white shadow-spotify-shadow absolute top-1/2 left-[var(--volume-progress)] -translate-y-1/2 opacity-0 -translate-x-1/2 group-hover:opacity-100"></div>
						</div>
					</div>
				</div>
				<button>
					<Icon src="fullScreen" size={16} className="text-white text-opacity-70 hover:text-opacity-100" />
				</button>
			</div>
		</div>
	)
}
